export class Poll {
    public id: number;
    public date: Date;
    public objective: string;
    public objectiveText: string;
    public facility: number;
    public personnel: number;
    public experience: number;
    public recommend: number;

    constructor() { }
}